module.exports = __webpack_public_path__ + "static/media/Sail-Away.b4359c42.jpg";